module.exports = __webpack_public_path__ + "img/telkomsel-br_01.790daaef.svg";